















































































































































































































import { mapGetters } from 'vuex';
import { types } from '../../store/types/types.js';
import { docTypes } from '../../../shared/enums/docTypes';
import { portalRoles } from '../../../shared/enums/portalRoles';
import { moduleTypes } from '../../../shared/enums/moduleTypes';
import { parentTypes } from '../../../shared/enums/parentTypes';
import { mediaTypes } from '../../../shared/enums/mediaTypes';
import { permissionEnum } from '../../../shared/enums/permissionEnum';
import MediaTagHandling from '../../../shared/PageFragments/Media/MediaTagHandling.vue';
import VideoThumbnail from '../../../shared/PageFragments/Media/VideoThumbnail.vue';
import SoundThumbnail from '../../../shared/PageFragments/Media/SoundThumbnail.vue';
import { mediaUtil } from '../../../shared/utils/mediaUtil';
import { useUserProfileStore } from '../../../shared/stores';
import { computed, defineComponent, PropType, toRef } from 'vue';
import { useAttachmentScan } from '../../../shared/composables/useAttachmentScan';
import { ScanningStatusEnum } from '../../../shared/enums/scanningStatus.enum';
import { AttachmentModel } from '../../../shared/models/attachment.model';
import AulaImg from '../../../shared/components/AulaImg.vue';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import Button from '../../../shared/directives/button.js';

export default defineComponent({
  directives: {
    Button,
  },
  props: {
    attachment: { type: Object as PropType<AttachmentModel>, default: () => {} },
    mediasUpdated: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    selectedMedia: { type: Array, default: () => [] },
    allowSelected: { type: Boolean, default: true },
    onlyTags: { type: Boolean, default: false },
    showMediaData: { type: Boolean, default: true },
    showThumbnail: { type: Boolean, default: true },
    largeThumbnail: { type: Boolean, default: false },
    allowTaggingForAll: { type: Boolean, default: false },
    parent: { type: String, default: 'aula' },
    fileRemoveWarningMessage: {
      type: String,
      default: 'GALLERY_DELETE_MEDIA_CONFIRM',
    },
    institutionCodeForTagging: { type: String, default: null },
    longText: { type: Boolean, default: false },
  },
  setup(props) {
    const attachment = toRef(props, 'attachment');
    const { scanningText, scanningStatus, isDisabled } = useAttachmentScan(
      attachment,
      props.longText ? 'long' : 'short'
    );
    const fileName = computed(() => props.attachment.name || props.attachment.media.file.name);
    const userProfile = useUserProfileStore().institutionProfile;
    const isMediaVisible = computed(
      () =>
        scanningStatus.value !== ScanningStatusEnum.BLOCKED ||
        props.attachment.creator.profileId === userProfile.profileId
    );

    return {
      isMediaVisible,
      scanningText,
      scanningStatus,
      isDisabled,
      fileName,
      ScanningStatusEnum,
    };
  },
  data: function () {
    return {
      title: this.attachment.media != null && this.attachment.media.title != null ? this.attachment.media.title : '',
      description:
        this.attachment.media != null && this.attachment.media.description != null
          ? this.attachment.media.description
          : '',
      tags: this.attachment.media != null && this.attachment.media.tags != null ? this.attachment.media.tags : [],
      existingTags:
        this.attachment.media != null && this.attachment.media.tags != null ? this.attachment.media.tags : [],
      missingTags:
        this.attachment.media != null && this.attachment.media.missingTags != null
          ? this.attachment.media.missingTags
          : false,
      resetInput: false,
      selected: false,
      parentTypes: parentTypes,
      docTypes: docTypes,
      portalRoles: portalRoles,
      mediaTypes: mediaTypes,
      moduleTypes: moduleTypes,
      url: '',
      rotationDegree: 0,
      allowedFormatsForRotation: ['png', 'jpeg', 'jpg', 'bmp'],
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    ...mapGetters({
      isMobile: types.GET_IS_MOBILE,
      children: types.GET_CHILDREN,
      institutions: types.GET_INSTITUTIONS,
      hasPermission: types.HAS_PERMISSION,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    taggedUserText() {
      if (this.tags.length === 0) {
        return '';
      }
      const firstTag = this.$getProfileDisplayName(this.tags[0]);
      const moreTags = this.tags.length > 1 ? ` + ${this.tags.length - 1} ${this.$getText('OTHERS')}` : '';
      return firstTag + moreTags;
    },
    tagMediaButtonText() {
      return this.$getText('GALLERY_ADD_TAGS');
    },
    imgClasses() {
      const classes = [];
      if (this.rotationDegree === 90 || this.rotationDegree === 270) {
        classes.push('vertical-rotated');
      }
      if (this.largeThumbnail) {
        classes.push('thumbnail-large');
      }
      return classes;
    },
    mediaIsValidFormatForRotation() {
      const fileNameSplit = this.attachment.name.split('.') || '';
      const ext = fileNameSplit[fileNameSplit.length - 1].toLowerCase();
      return this.allowedFormatsForRotation.includes(ext);
    },
    mediaType() {
      if (this.attachment.media != null) {
        return this.attachment.media.mediaType;
      }
      return null;
    },
    canHandleMedia() {
      return this.hasPermission(permissionEnum.HANDLE_MEDIA);
    },
  },
  watch: {
    attachment() {
      this.updateMediaData();
    },
    mediasUpdated() {
      this.updateMediaData();
    },
    'attachment.media.tags'() {
      if (this.attachment.media.tags != this.existingTags) {
        this.existingTags = this.attachment.media.tags;
        this.tags = this.attachment.media.tags;
      }
    },
    'attachment.media.file'() {
      this.getS3Object();
    },
  },
  mounted() {
    if (this.selectedMedia != null && this.selectedMedia.filter(m => m.guid == this.attachment.guid).length > 0) {
      this.selected = true;
    }
    if (this.parent == parentTypes.DOCUMENTS) {
      this.emitMediaData();
    }
    this.getS3Object();
  },
  methods: {
    onDropdownShown() {
      this.$nextTick(() => {
        this.$el.querySelector('input.el-select__input').focus();
      });
    },
    rotateClockwise() {
      const thumbnail = this.$refs.thumbnail.$el;
      this.rotationDegree += 90;
      if (this.rotationDegree > 270) {
        this.rotationDegree = 0;
      }
      this.emitMediaData();
      thumbnail.style.transform = 'rotate(' + this.rotationDegree + 'deg)';
    },
    rotateCounterClockwise() {
      const thumbnail = this.$refs.thumbnail.$el;
      this.rotationDegree -= 90;
      if (this.rotationDegree < 0) {
        this.rotationDegree = 270;
      }
      this.emitMediaData();
      thumbnail.style.transform = 'rotate(' + this.rotationDegree + 'deg)';
    },
    downloadAttachment(attachment) {
      if (this.isMedia(attachment)) {
        return;
      }
      if (attachment.file != null && attachment.file.url != undefined) {
        this.downloadFileFromUrl(attachment.file.url, attachment.file.name);
      } else if (attachment.media != null) {
        window.open(attachment.media.file.url);
      } else if (attachment.link != null) {
        window.open(attachment.link.url);
      }
    },
    downloadFileFromUrl(url, fileName) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = url;
      a.download = fileName;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    },
    isMedia(attachment) {
      if (attachment != null && attachment.media != null && this.mediaType != mediaTypes.LINK) {
        let fileNameSplit = '';
        if (attachment.name != null) {
          fileNameSplit = attachment.name.split('.');
        } else {
          fileNameSplit = attachment.media.file.name.split('.');
        }
        const ext = fileNameSplit[fileNameSplit.length - 1];
        if (
          mediaUtil.isMedia(ext) == mediaTypes.SOUND ||
          mediaUtil.isMedia(ext) == mediaTypes.IMAGE ||
          mediaUtil.isMedia(ext) == mediaTypes.VIDEO
        ) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    isLink(attachment) {
      if (attachment != null && attachment.link != null) {
        return true;
      }
      return false;
    },
    selectMedia() {
      let emitData = { checked: this.selected, guid: this.attachment.guid, url: null };

      if (this.isMobile) {
        if (!this.allowSelected) {
          return;
        }
        this.selected = !this.selected;
        emitData = {
          checked: this.selected,
          guid: this.attachment.guid,
          url: this.url,
        };
      }
      this.$emit('mediaSelected', emitData);
    },
    cancelTagging() {
      this.$refs.mediaTagDropdown.hide();
    },
    addTagsToMedia(addedTags) {
      this.tags = this.tags.concat(addedTags);
      this.onEditTags();
      this.$refs.mediaTagDropdown.hide();
      this.$nextTick(() => {
        this.$refs.mediaTagDropdown.show();
      });
    },
    onEditTags() {
      // AulaSearchRecipient returns selected groups and their members, filter out group DTOs, keep members only
      this.tags = this.tags.filter(item => item.type !== docTypes.GROUP.toLowerCase());
      this.emitMediaData();
    },
    removeTagFromMedia(tagToRemove) {
      const tagIndexToRemove = this.tags.findIndex(tag => tag.id === tagToRemove.id);
      this.tags.splice(tagIndexToRemove, 1);
      setTimeout(() => {
        this.$refs.mediaTagDropdown.show();
      }, 0);
      this.onEditTags();
    },
    emitMediaData() {
      const attachment = this.attachment;
      if (attachment.media) {
        attachment.media.title = this.title;
        attachment.media.rotationDegree = this.rotationDegree;
        attachment.media.description = this.description;
        attachment.media.tags = this.tags;
        this.$emit('mediaInfoUpdated', attachment);
      }
    },
    updateMediaData() {
      if (this.attachment.media != null) {
        if (this.attachment.media.title != this.title) {
          this.title = this.attachment.media.title;
        }
        if (this.attachment.media.description != this.description) {
          this.description = this.attachment.media.description;
        }
        if (this.attachment.media.tags != this.tags && this.selected) {
          this.resetInput = !this.resetInput;
          this.existingTags = this.attachment.media.tags;
          this.tags = this.attachment.media.tags;
        }
        if (this.attachment.media.missingTags != null) {
          this.missingTags = this.attachment.media.missingTags;
        }
      }
      if (this.selectedMedia != null && this.selectedMedia.filter(m => m.guid == this.attachment.guid).length > 0) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    },
    getS3Object() {
      if (this.attachment.media != null) {
        this.url = this.attachment.media.extraSmallThumbnailUrl || this.attachment.media.file.url;
        this.$emit('updateUrl', {
          guid: this.attachment.guid,
          url: this.url,
        });
      }
    },
  },
  components: {
    Icon,
    AulaImg,
    SoundThumbnail,
    VideoThumbnail,
    MediaTagHandling,
  },
});
